import { BevPageTypes } from "../BevPageTypes";
import { convertToNumber } from "./generalHelpers";

export const getBorderColor = (
  singleUnit: BevPageTypes.TUnit,
  selectedUnitTypeId: string | undefined
) => {
  return selectedUnitTypeId &&
    singleUnit.unit_type.id === selectedUnitTypeId &&
    singleUnit.rental_status === "Vacant"
    ? `activeBorder`
    : `inActiveBorder`;
};
export const getBackgroundColor = (
  singleUnit: BevPageTypes.TUnit,
  selectedUnitId: any
) =>
  selectedUnitId && singleUnit.id === selectedUnitId
    ? `hasActiveBackground`
    : `hasInactiveBackground`;

export const ZIndex = (singleUnit: BevPageTypes.TUnit, selectedUnitId: any) =>
  selectedUnitId &&
  convertToNumber(singleUnit.id) === convertToNumber(selectedUnitId)
    ? "100"
    : 1;

export const isClickableUnit = (
  singleUnit: BevPageTypes.TUnit,
  selectedUnitTypeId: string | undefined
) => {
  return !!(
    selectedUnitTypeId &&
    singleUnit.unit_type.id === selectedUnitTypeId &&
    singleUnit.rental_status === "Vacant"
  );
};
